<template>
	<div class="alterar-classificacao-itens-ata">
		<v-row>
			<v-col cols="12" sm="2">
				<span class="font-weight-bold">
					<label-personalizado nome-campo="Órgão Cedente"></label-personalizado>
				</span>
				<div class="py-3">{{ orgaoCedente.siglaOrgao }}</div>
			</v-col>
			<v-col cols="12" sm="2">
				<span class="font-weight-bold">
					<label-personalizado nome-campo="Saldo Atual"></label-personalizado>
				</span>
				<div class="py-3">{{ orgaoCedente.estoque | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</div>
			</v-col>

			<v-col cols="12" :sm="orgaoCedente.tipoAlteracaoSaldo === 'SUPRESSAO' ? 2 : 3">
				<label-personalizado nome-campo="Órgão Cessionário" :obrigatorioPorPadrao="true"></label-personalizado>
				<v-autocomplete
					id="combo-autocomplete-orgaos-cessionarios"
					v-model="filtro.orgaoCessionario"
					v-validate="{ required: true }"
					name="Orgao"
					dense
					clearable
					:items="orgaos"
					placeholder="Busque por sigla"
					class="alinhar-autocomplete-siglas"
					item-value="id"
					item-text="nomeFormatado"
					return-object
					:rules="regrasOrgao"
				></v-autocomplete>
			</v-col>

			<v-col v-if="orgaoCedente.tipoAlteracaoSaldo === 'SUPRESSAO'" cols="12" sm="2">
				<span class="font-weight-bold">
					<label-personalizado nome-campo="Saldo Atual do Órgão"></label-personalizado>
				</span>
				<div class="py-3">
					{{
						(filtro.orgaoCessionario ? filtro.orgaoCessionario.estoqueAtual : null)
							| rpCurrencyFilter('', numeroCasasDecimaisQtde)
					}}
				</div>
			</v-col>

			<v-col cols="12" :sm="orgaoCedente.tipoAlteracaoSaldo === 'SUPRESSAO' ? 2 : 3">
				<label-personalizado
					nome-campo="Qtd Transferência"
					class="mb-2"
					obrigatorio-por-padrao
				></label-personalizado>
				<az-money
					id="idQuantiadeValorTransferencia"
					required
					v-model="transferirSaldo.quantidadeTransferencia"
					placeholder="Informe quantidade"
					:negative="false"
					:requeridMessage="'Quantidade deve ser preenchido!'"
					:precision="numeroCasasDecimaisQtde"
					:maxLength="300"
					prefix=""
					class="ma-0 py-0"
				></az-money>
			</v-col>
			<v-col cols="12" sm="2">
				<label-personalizado
					nome-campo="Número Ofício"
					class="mb-2"
					obrigatorio-por-padrao
				></label-personalizado>
				<v-text-field
					placeholder="Informe o número"
					variant="underlined"
					v-model="transferirSaldo.numeroOficio"
					class="ma-0 py-0"
					:rules="regrasNumeroOficio"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" class="py-8">
				<label-personalizado
					nome-campo="Justificativa Cedência"
					obrigatorio-por-padrao
					class="label-motivo"
				></label-personalizado>
				<v-textarea
					id="justificativa"
					v-model="justificativa"
					:rules="regrasJustificativa"
					rows="2"
					class="ma-0 py-0"
					:max="limiteCaracteresJustificativa"
					:counter="limiteCaracteresJustificativa"
					placeholder="Informe a justificativa do remanejamento"
					no-resize
					@input="corrigirTexto"
				></v-textarea>

				<div class="az-back-button">
					<v-btn color="primary" text depressed @click="$emit('recarregar-listagem')">
						<v-icon>mdi-chevron-left</v-icon> Voltar para listagem
					</v-btn>
				</div>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { actionTypes, mutationTypes } from '@/core/constants'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import { mapState } from 'vuex'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'

export default {
	name: 'transferir',
	components: { LabelPersonalizado },
	mixins: [validacaoFormulario],
	data() {
		return {
			regrasJustificativa: [
				(value) => this.regraObrigatoriedade(value, 'A justificativa é obrigatório.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						this.limiteCaracteresJustificativa,
						`O campo de justificativa deve ser igual ou menor que ${this.limiteCaracteresJustificativa} caracteres!`,
					),
			],
			regrasOrgao: [
				(value) => {
					if (value && value.id) return true

					return 'O órgão deve ser preenchido!'
				},
			],
			regrasNumeroOficio: [(value) => !!value || 'Número ofício deve ser preenchido!'],
			orgaos: [],
			limiteCaracteresJustificativa: 300,
		}
	},
	computed: {
		...mapState({
			itemSelecionado: (state) => state.itemAta.itemSelecionado,
			orgaoCedente: (state) => state.itemAta.transferencia.transferir.orgaoCedente,
			transferirSaldo: (state) => state.itemAta.transferencia.transferir.transferirSaldo,
			filtro: (state) => state.itemAta.transferencia.transferir.filtro,
			informacoesAta: (state) => state.ata.informacoesAta,
		}),
		justificativa: {
			get() {
				return this.$store.state.itemAta.transferencia.transferir.transferirSaldo.justificativa
			},
			set(justificativa) {
				this.$store.commit(mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.SET_JUSTIFICATIVA, justificativa)
			},
		},
		numeroCasasDecimaisQtde: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisQtde
			},
		},
	},
	watch: {
		filtro(id) {
			this.$store.state.itemAta.transferencia.transferir.transferirSaldo.idUoCessionario = id
		},
	},
	async mounted() {
		this.transferirSaldo.idUoCedente = this.orgaoCedente.idUo
		this.transferirSaldo.idItemAta = this.itemSelecionado.id
		this.filtro.idCedente = this.orgaoCedente.idUo
		this.filtro.idItemAta = this.itemSelecionado.id
		this.filtro.idAta = this.informacoesAta.id
		this.filtro.tipoAlteracaoSaldo = this.orgaoCedente.tipoAlteracaoSaldo

		await this.carregarOrgaosCessionarios()
	},
	methods: {
		async carregarOrgaosCessionarios() {
			const { itens } = await this.$store.dispatch(actionTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.BUSCAR_ORGAOS)
			this.orgaos = itens
		},
		corrigirTexto() {
			if (this.justificativa) this.justificativa = this.justificativa.trim()
		},
	},
}
</script>

<style lang="stylus">
.alterar-classificacao-itens-ata {

	.label-motivo {
		margin-top: (-36 / 16)rem !important
	}
}
.alinhar-autocomplete-siglas {
	padding-top: 4.6% !important
}
</style>
